import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const EsquemasContractualesView = lazy(() => import('../../container/configuracion/esquemasContractuales/Index'));
const EsquemasContractualesForm = lazy(() => import('../../container/configuracion/esquemasContractuales/Form'));

const EsquemasContractualesRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
             <Route path= {`${path}/catalogos/esquemas-contractuales/listado`} component = { EsquemasContractualesView } />
             <Route path={`${path}/catalogos/esquemas-contractuales/agregar`} component = { EsquemasContractualesForm } />
             <Route exact path = {`${path}/catalogos/esquemas-contractuales/editar/:id`} component = { EsquemasContractualesForm } />
            </Switch>
  );
};

export default EsquemasContractualesRoute;

